import { forwardRef, KeyboardEvent, ReactNode } from "react";
import { Text } from "@chakra-ui/react";

import { ILocationSuggestion } from "utils/geo";
import CInput from "components/Chakra/Input";

type SearchInputProps = {
  initialValue?: string;
  onChange: (value: string) => void;
  onFocus: (isFocused: boolean, value: string) => void;
  onBlur: () => void;
  onEnter?: (value: ILocationSuggestion) => void;
  onTab?: (e: KeyboardEvent<HTMLInputElement>) => void;
  rightIcon?: ReactNode;
  value?: string;
  error?: boolean;
  firstItem: ILocationSuggestion;
  isNewInsertForm: boolean;
  placeholder?: string;
};

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      onChange,
      onTab,
      onFocus,
      onBlur,
      onEnter,
      rightIcon,
      value,
      error,
      firstItem,
      isNewInsertForm,
      placeholder,
    },
    ref,
  ) => (
    <CInput
      textTransform="capitalize"
      value={value}
      w="100%"
      label={
        !isNewInsertForm && (
          <Text
            variant="form-label"
            color={error ? "ud-error" : "ud-grey-600"}
            data-test="offer.address.town.townText"
          >
            Město
            <Text as="span" pl="3px" color="ud-error">
              *
            </Text>
          </Text>
        )
      }
      id="village-search-input"
      data-test="offer.address.town.searchInput"
      autoCorrect="off"
      ref={ref}
      placeholder={placeholder}
      fontWeight="bold"
      _placeholder={{ fontWeight: "normal" }}
      onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
          onEnter && onEnter(firstItem);
        }
        if (e.key === "Tab") {
          onTab && onTab(e);
        }
      }}
      onFocus={(e) => {
        onFocus(true, e.target.value);
      }}
      onChange={({ currentTarget: { value: val } }) => {
        onChange && onChange(val);
      }}
      onBlur={onBlur}
      rightElement={!isNewInsertForm && rightIcon}
      backgroundColor={isNewInsertForm ? "ud-white" : "inherit"}
      borderColor={error ? "ud-error" : "ud-grey-200"}
    />
  ),
);

export default SearchInput;
